import styled, { css } from "styled-components";

import { TextField as DefaultTextField } from "@material-ui/core";

import { COLORS } from "constants/colorScheme";

export const TextField = styled(DefaultTextField)`
  && {
    .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline {
      border-color: ${COLORS.RED};
    }
  }
`;
export const CharCounter = styled.span`
  text-align: right;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${({ withMaxLength }) => (withMaxLength ? "-18px" : "0px")};
  ${({ width }: { width?: string }) =>
    css`
      width: ${width ?? "100%"};
    `}

  &:not(:last-child) {
    margin-right: 32px;
  }
`;
